module.exports = __webpack_public_path__ + "img/Holger.ab5a5b4d.png";